import {
  Tab as ChakraTab,
  useMergeRefs,
  forwardRef,
} from '@chakra-ui/react-v2';
import type { TabProps as ChakraTabProps } from '@chakra-ui/react-v2';
import { useRef } from 'react';

export type TabProps = ChakraTabProps;

export const Tab = forwardRef<TabProps, 'button'>(
  ({ onFocus, children, ...restProps }, ref) => {
    // Create an internal ref for scrollIntoView.
    const internalRef = useRef<Element>();

    // Merge the internal ref with any external ref.
    const refs = useMergeRefs(internalRef, ref);

    return (
      <ChakraTab
        ref={refs}
        {...restProps}
        onFocus={(focusProps) => {
          onFocus?.(focusProps);
          internalRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }}
      >
        {children}
      </ChakraTab>
    );
  },
);
Tab.displayName = 'Tab';
